import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { get } from '../api/apiService';
import { useTheme } from '../theming/default_theme';
import Menu from './Menu/Menu';
import Header from './Header';
import { convertDateFormat, formatDate } from '../utils/dateUtils';
import { useNavigate } from 'react-router-dom';
import StatusBadge from './StatusBadge';
import { apiEndPoints } from '../api/apiEndPoints';




const HospitalDetailsPage: React.FC = () => {

    const theme = useTheme();
    const navigate = useNavigate();
    const { hospitalId } = useParams();
    const location = useLocation();
    const hospital = location.state?.hospital;
    const isSpectacleRequestScreen = location.state?.isSpectacleRequestScreen || false;
    const [hospitalRefList, setHospitalRefList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageCountIndex, setPageCountIndex] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [selectedTab, setSelectedTab] = useState(isSpectacleRequestScreen ? 'Spectacle Request' : 'Referrals');
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [pageNumber, setPageNumber] = useState(0);
    const [selectedPage, setSelectedPage] = useState('0');
    const [pagesToDisplay, setPagesToDisplay] = useState(Array.from({ length: 5 }, (_, index) => index + 1));


    useEffect(() => {
        if (!hospital) {
            navigate('/Landingpage', { replace: true });
        }
        const fetchHospitalReferralsById = async (hospitalId: string) => {
            try {
                setLoading(true);
                console.log('Fetching hospital referrals for hospitalId:', hospital);
                console.log(`/referrals/hospital/${hospitalId}`);
                const url = `${apiEndPoints.referralsHospitalEndPoint}/${hospitalId}`;
                const response = await get(url);
                console.log('API Response:', response);
                setLoading(false);
                if (response) {
                    setHospitalRefList(response);
                }
                else
                    console.log('refresh and check');
            } catch (err) {

            }
        };
        if (hospitalId)
            fetchHospitalReferralsById(hospitalId);
        else
            console.error('hospital not selected');
    }, [hospital, navigate])

    if (!hospital) {
        return null;
    }

    const handleHospitalClick = () => {

        console.log('Hospital clicked');
        navigate('/LandingPage');
    };

    const handlePageChange = async (event: React.MouseEvent<HTMLDivElement>) => {
        setSelectedPage(event.currentTarget.innerText);
        console.log('selectedPage:', selectedPage);
        console.log('selectedPage.includesnext --:', selectedPage.includes('Next'));
        console.log('pageNumber:', pageNumber);
        if (selectedPage.includes('Prev')) {
            if (pageNumber == 0) {

            }
            else {

                if (pageNumber % 5 === 0) {
                    setPagesToDisplay(Array.from({ length: 5 }, (_, index) => index - 5));

                }
                setSelectedPage((pageNumber - 1).toString());


            }
            console.log('selectedPage:', selectedPage);
        }

        else if (selectedPage.includes('Next')) {
            console.log('selectedPage:-', selectedPage);
            console.log('you are in next');

            if (pageNumber == totalPages - 1) {

            }
            else {
                if ((pageNumber % 5) === 4) {
                    setPagesToDisplay(Array.from({ length: 5 }, (_, index) => index + 6));

                }
                setSelectedPage((pageNumber + 1).toString());
            }
        }
    }


    return (

        <div className={` flex flex-row justify-start items-start h-screen w-screen`} >

            <Menu />
            <div className="flex flex-col justify-start items-start w-full h-full overflow-hidden">
                <Header />
                <div className="flex flex-col h-full w-full border border-2 mt-2 overflow-hidden" style={{ backgroundColor: theme.colors.background }}>
                    <div className="flex flex-row justify-start text-left items-left ml-5"><div className={`cursor-pointer`} onClick={() => handleHospitalClick()}> {isSpectacleRequestScreen ? 'Spectacles Requests' : 'Hospitals'}</div>
                        <span className="px-2">{`>`}</span>
                        <div>Hospital Details</div></div>
                    <div className={`flex  flex-col w-[95%] h-[50%] mt-2 ml-5 bg-[${theme.colors.surfaceCard}] border-r-${theme.borders.color} rounded-xl overflow-hidden`}>
                        <div className={`flex flex-col w-full pl-5 justify-start items-start text-center text-[${theme.colors.text}] font-bold`} style={{ fontSize: theme.typography.h1.fontSize, fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, color: theme.colors.text }}>
                            <div className="flex flex-row w-full justify-between text-start items-start pt-2 pl-5 gap-x-10 overflow-hidden">
                                <div className="flex flex-row items-center text-[#222222] gap-x-2 whitespace-nowrap">
                                    <img src="/hospital_details.png" alt="HospitalDetails" style={{ width: '50px', height: '50px', marginRight: "1%" }} />
                                    {hospital.name}
                                </div>
                                <div className="flex flex-row justify-center items-center gap-x-1">
                                    <span className="text-[#5A6178]">ID</span>
                                    <span>{hospital.hospitalCode.toUpperCase()}</span>
                                </div>
                                <div className="flex flex-row items-center pr-8">
                                    <StatusBadge
                                        backgroundColor={hospital.status ? "#E8F6EE" : "#E8F6EE"}
                                        textColor={hospital.status ? "#27AE60" : "#27AE60"}
                                        text={hospital.status ? "Active" : "In Active"}
                                    />
                                </div>
                            </div>


                            <hr className="flex flex-row justify-center border-t-2 border-[#27AE60] w-[99%] pl-2 pr-2 mt-1" />
                        </div>

                        <div
                            className="grid grid-cols-2 w-[98%] h-full pl-1 pt-4 ml-1 mb-2 gap-x-20 overflow-y-auto"
                            style={{ maxHeight: 340 }} // Adjust maxHeight as needed for your layout
                        >

                            {/* Column 1 */}
                            <div className="grid grid-cols-2 w-[85%] h-full pl-5 ml-5 gap-x-0 mr-20" style={{ rowGap: '0px' }}>
                                {/* Row 1 */}
                                <div className="flex flex-row gap-x-4">
                                    <img src="/registered_on.png" alt="registered_on" className="w-8 h-8 mt-2" />
                                    <div className="font-bold whitespace-nowrap mt-2">Registered On</div>
                                </div>
                                <div className="font-medium text-[#5A6178] mt-2">{hospital.registration_date}</div>


                                {/* Row 2 */}
                                <div className="flex flex-row gap-x-4">
                                    <img src="/location.png" alt="location" className="w-8 h-8 mt-2" />
                                    <div className="font-bold mt-2">Location</div>
                                </div>
                                <div className="font-regular mt-2">
                                    <span
                                        className={`text-[${theme.colors.detailtext}] text-wrap`}
                                        style={{
                                            color: theme.colors.detailtext,
                                            fontWeight: theme.typography.fontWeightMedium,
                                        }}
                                    >
                                        {hospital.address.address1}, {hospital.address.city}, {hospital.address.state}, {hospital.address.pincode}
                                    </span>
                                </div>

                                {/* Row 3 */}
                                <div className="flex flex-row gap-x-4">
                                    <img src="/coordinator.png" alt="coordinator" className="w-8 h-8 mt-2" />
                                    <div className="font-bold mt-2">Coordinator</div>
                                </div>
                                <div className="font-regular mt-2">
                                    <span
                                        className={`text-[${theme.colors.detailtext}] text-wrap`}
                                        style={{
                                            color: theme.colors.detailtext,
                                            fontWeight: theme.typography.fontWeightMedium,
                                        }}
                                    >
                                        {hospital.coordinator}<br />
                                        {hospital.coordinator_phonenumber}<br />
                                        {hospital.coordinator_email}
                                    </span>
                                </div>

                            </div>


                            {/* Column 2 */}
                            <div className="grid grid-cols-2 grid-rows-2  gap-y-3 w-[85%] h-full ml-10">
                                <div className="flex flex-row gap-x-4">
                                    <img src="/services.png" alt="services" className="w-8 h-8 mt-2" />
                                    <div className="font-bold whitespace-nowrap mt-2">Services</div>
                                </div>
                                <div className="font-medium mt-2 text-[#5A6178]">
                                    {hospital.services.map((service: string, idx: number) => (
                                        <div key={idx}>{service}</div>
                                    ))}
                                </div>

                                <div className="flex flex-row gap-x-4">
                                    <img src="/total_referrals.png" alt="total_referrals" className="w-8 h-8 mt-1" />
                                    <div className="font-bold whitespace-nowrap mt-2">Total Referrals</div>
                                </div>
                                <div className="font-medium text-[#5A6178] mt-2">{hospital.referralCount}</div>
                            </div>


                        </div>



                    </div>

                    <div className={`flex flex-col w-[95%] h-[50%] mt-5 ml-5 mb-5 bg-[${theme.colors.surfaceCard}] border-r-${theme.borders.color} border-black rounded-xl`}>
                        <div className={`flex flex-col w-full h-auto ml-[8px] justify-center items-start text-center`} style={{ fontSize: theme.typography.fontSize, fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightMedium }}>
                            <div className={`flex flex-row w-[30%] h-[25%] ml-5 justify-start items-start rounded-full`}>
                                <div className={`flex flex-row h-full p-4 rounded-full bg-[${selectedTab === 'Referrals' ? theme.colors.surface : '#F5F1E0'}] text-${selectedTab === 'Referrals' ? 'white' : 'black'} text-center justify-center items-center cursor-pointer`} onClick={() => setSelectedTab('Referrals')}>Referrals</div>
                                <div className={`flex flex-row h-full p-4 rounded-full bg-[${selectedTab === 'Spectacle Request' ? theme.colors.surface : '#F5F1E0'}] text-${selectedTab === 'Spectacle Request' ? 'white' : 'black'} text-center justify-center items-center text-nowrap cursor-pointer`} onClick={() => setSelectedTab('Spectacle Request')}>Spectacle Requests</div>
                            </div>
                        </div>


                        <div
                            className={`flex justify-start items-center ml-[24px] w-[96%] h-[76%] border border-[${theme.borders.greyBorder}] rounded-xl`}
                            style={{
                                backgroundColor: theme.colors.secondary,
                                justifyItems: "start",
                                marginTop: 15,
                                alignItems: "start",
                                overflowY: "auto"
                            }}
                        >
                            {selectedTab === 'Referrals' ?
                                (<table className="table-fixed h-full text-start" style={{ width: "100%", height: "100%", border: theme.borders.color, borderRadius: "8px", overflow: "auto", justifyItems: "start", alignItems: "start", justifyContent: "left", textAlign: 'left', fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.fontSize, color: theme.colors.text }}>
                                    <thead className={`w-full sticky top-0  font-bold bg-[${theme.colors.surfaceCard}]`} style={{ borderBottomColor: theme.borders.color }}>
                                        <tr>
                                            <th
                                                className="w-[30%] text-start px-4 py-2"
                                                style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                            >
                                                Referred
                                            </th>
                                            <th
                                                className="w-[20%] text-start px-4 py-2"
                                                style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                            >
                                                Age and Gender
                                            </th>
                                            <th
                                                className="w-[20%] text-start px-4 py-2"
                                                style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                            >
                                                Referred By
                                            </th>
                                            <th
                                                className="w-[20%] text-start px-4 py-2"
                                                style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                            >
                                                Referred On
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className={`w-full text-start  border border-[${theme.borders.color}]`}>
                                        {(hospitalRefList && hospitalRefList.length > 0) ? (
                                            hospitalRefList.map((hospitalRef: any, index: number) => (
                                                <tr key={index} className={`w-full text-start border border:theme.borders.color`}>
                                                    <td className={`w-full h-[10%] text-start block px-4 py-2 align-top`}>{hospitalRef.patientName}</td>
                                                    <td className="h-[10%] w-full px-4 py-2 text-start align-top">{hospitalRef.age}, {hospitalRef.gender}</td>
                                                    <td className={`h-[10%] w-full text-start block px-4 py-2 align-top`}>{hospitalRef.ambassadorName}</td>
                                                    <td className="h-[10%] px-4 py-2 align-top">{convertDateFormat(hospitalRef.createdAt)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4} className="text-center py-10" style={{
                                                    fontFamily: theme.typography.fontFamily,
                                                    fontWeight: theme.typography.fontWeightBold,
                                                    fontSize: theme.typography.fontSize,
                                                    color: theme.colors.text,
                                                }}>
                                                    No referrals available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>) : (
                                    <table className="table-fixed h-full text-start" style={{ width: "100%", height: "100%", border: theme.borders.color, borderRadius: "8px", overflow: "auto", justifyItems: "start", alignItems: "start", justifyContent: "left", textAlign: 'left', fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.fontSize, color: theme.colors.text }}>
                                        <thead className={`w-full sticky top-0 font-bold bg-[${theme.colors.surfaceCard}]`} style={{ borderBottomColor: theme.borders.color }}>
                                            <tr>
                                                <th
                                                    className="w-[30%] text-start px-4 py-2 sticky top-0 z-10]"
                                                    style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                                >
                                                    Referred
                                                </th>
                                                <th
                                                    className="w-[20%] text-start px-4 py-2 sticky top-0 z-10]"
                                                    style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                                >
                                                    Age and Gender
                                                </th>
                                                <th
                                                    className="w-[20%] text-start px-4 py-2 sticky top-0 z-10]"
                                                    style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                                >
                                                    Referred On
                                                </th>
                                                <th
                                                    className="w-[20%] text-start px-4 py-2 sticky top-0 z-10]"
                                                    style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                                >
                                                    Eye
                                                </th>
                                                <th
                                                    className="w-[20%] text-start px-6 py-2 sticky top-0 z-10]"
                                                    style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                                >
                                                    Status
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className={`w-full text-start border border-[${theme.borders.color}]`}>
                                            {(() => {
                                                const spectacleList = hospitalRefList.filter((hospitalRef: any) => hospitalRef.isSpectacleRequested);
                                                return spectacleList.length > 0 ? (
                                                    spectacleList.map((hospitalRef: any, index: number) => (
                                                        <tr key={index} className={`w-full text-start border border:theme.borders.color`}>
                                                            <td className={`w-full h-[10%] text-start block px-4 py-2 align-top`}>{hospitalRef.patientName}</td>
                                                            <td className="h-[10%] w-full px-4 py-2 align-top">{hospitalRef.age}, {hospitalRef.gender}</td>
                                                            <td className={`h-[10%] w-full text-start block px-4 py-2 align-top`}>{convertDateFormat(hospitalRef.createdAt)}</td>
                                                            <td className="h-[10%] px-4 py-2 align-top">
                                                                <div className="flex flex-row justify-start items-center gap-x-2">
                                                                    <div className="flex flex-col block pr-2 align-top space-0"><span>RE</span>
                                                                        <span style={{ color: theme.colors.detailtext }}>SPH:-{hospitalRef.rightEye?.sph}</span>
                                                                        <span style={{ color: theme.colors.detailtext }}>CYL:-{hospitalRef.rightEye?.cyl}</span>
                                                                        <span style={{ color: theme.colors.detailtext }}>AXIS:-{hospitalRef.rightEye?.axis}</span>
                                                                    </div>
                                                                    <div className="flex flex-col block pr-2 align-top"><span>LE</span>
                                                                        <span style={{ color: theme.colors.detailtext }}>SPH:-{hospitalRef.leftEye?.sph}</span>
                                                                        <span style={{ color: theme.colors.detailtext }}>CYL:-{hospitalRef.leftEye?.cyl}</span>
                                                                        <span style={{ color: theme.colors.detailtext }}>AXIS:-{hospitalRef.leftEye?.axis}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="h-[10%] px-4 py-2 items-center justify-center align-top">
                                                                {(() => {
                                                                    const status = hospitalRef.status?.toLowerCase();
                                                                    switch (status) {
                                                                        case "delivered":
                                                                            return (
                                                                                <StatusBadge
                                                                                    backgroundColor="#E8F6EE"
                                                                                    textColor="#27AE60"
                                                                                    text="Delivered"
                                                                                />
                                                                            );
                                                                        case "referred":
                                                                            return (
                                                                                <StatusBadge
                                                                                    backgroundColor="#F2F8FD"
                                                                                    textColor="#2980B9"
                                                                                    text="Referred"
                                                                                />
                                                                            );
                                                                        default:
                                                                            return (
                                                                                <StatusBadge
                                                                                    backgroundColor="#FFF8DC"
                                                                                    textColor="#FFC107"
                                                                                    text="In Progress"
                                                                                />
                                                                            );
                                                                    }
                                                                })()}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={5} className="text-center py-10" style={{
                                                            fontFamily: theme.typography.fontFamily,
                                                            fontWeight: theme.typography.fontWeightBold,
                                                            fontSize: theme.typography.fontSize,
                                                            color: theme.colors.text,
                                                        }}>
                                                            No spectacle request available
                                                        </td>
                                                    </tr>
                                                );
                                            })()}
                                        </tbody>

                                    </table>
                                )
                            }


                        </div>
                    </div>


                </div>
            </div>



        </div>

    );

}
export default HospitalDetailsPage